const storageKeysHelper = <T extends Record<string, string>>(keys: T) => keys

// Składania pozwalająca dodać odpowiedni typ do obiektu STORAGEKEYS, tak aby użycie klucza 
// nie będącego w obiekcie wywołało błąd.
export const STORAGEKEYS = storageKeysHelper({
   ACCESS_TOKEN: 'ACCESS_TOKEN',
   USER_SESSION: 'USER_SESSION',
   SESSION_ID: 'SESSION_ID',
   IS_AFTER_BANK_VERIFICATION: 'IS_AFTER_BANK_VERIFICATION',
   JSC: 'JSC', 
   HDIM: 'HDIM',
   LOCATIONS: 'LOCATIONS',
   CURRENT_CITY_VALUE: 'CURRENT_CITY_VALUE',
   MOBYWATEL_CODE_VALIDITY_STARTING_TIME: 'MOBYWATEL_CODE_VALIDITY_STARTING_TIME',
   CURRENT_MOBYWATEL_CODE: 'CURRENT_MOBYWATEL_CODE',
   MOBYWATEL_IS_AFTER_FIRST_RENDER: 'MOBYWATEL_IS_AFTER_FIRST_RENDER',

   IS_MOBYWATEL_IDENTIFICATION_SUCCEED: 'IS_MOBYWATEL_IDENTIFICATION_SUCCEED',
   IS_MOBYWATEL_VERIFICATION_SUCCEED: 'IS_MOBYWATEL_VERIFICATION_SUCCEED',

   IS_VIDEO_VERIFICATION_DISABLED: 'IS_VIDEO_VERIFICATION_DISABLED',

   CLIENT_PESEL_RESERVED_CURRENT_BLOCKING_TIME_IN_SECONDS: 'CLIENT_PESEL_RESERVED_CURRENT_BLOCKING_TIME_IN_SECONDS',
   CLIENT_PESEL_RESERVED_IS_INTERVAL_RUNNING: 'CLIENT_PESEL_RESERVED_IS_INTERVAL_RUNNING',

   ANALYTICS_SERVICE_SENDED_EVENTS_NAMES: 'ANALYTICS_SERVICE_SENDED_EVENTS_NAMES',
   SPECIAL_HANDLING_BROKER_NAME: "SPECIAL_HANDLING_BROKER_NAME",
   CURRENT_SELECTED_BANK_NAME: "CURRENT_SELECTED_BANK_NAME",
} as const)